import _extends from "@babel/runtime/helpers/extends"; // A NOTE ON `max-width`
// —————————————————————————————————————————————————————————————————————————————
// While the use of `max-width` is discouraged @ XE — we’re mobile-first! — it’s
// not unwelcome PROVIDED THAT it’s justified. For example, if we need something
// like
//
//   `@media (min-width: 576px) and (max-width: 991px)`,
//
// we can add `max-width` to our set of MEDIA_QUERY constants.

import BREAKPOINT from "./breakpoint";
var entries = [["Xs", BREAKPOINT.xs], ["Sm", BREAKPOINT.sm], ["Md", BREAKPOINT.md], ["Lg", BREAKPOINT.lg], ["Xl", BREAKPOINT.xl], ["Xxl", BREAKPOINT.xxl]];
/**
 * Generates a map of query IDs as keys and media queries as values.
 *
 * @param {boolean} [excludeAtMedia] Indicates whether "@media" should be included in each media query.
 * @returns {object.<string, string>} Pairs of query IDs and media queries.
 */

var queryIdToMinWidthQuery = function queryIdToMinWidthQuery(excludeAtMedia) {
  return entries.reduce(function (map, _ref) {
    var size = _ref[0],
        breakpoint = _ref[1];
    return map["minWidth" + size] = (excludeAtMedia ? "" : "@media ") + "(min-width: " + breakpoint + "px)", map;
  }, {});
};

var excludeAtMedia = true;
export default _extends({}, queryIdToMinWidthQuery(), {
  withoutAtMedia: _extends({}, queryIdToMinWidthQuery(excludeAtMedia))
});